exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact .head[data-v-21ba3a83]{margin:20px 0 0 20px}.contact .head ul[data-v-21ba3a83]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;padding-left:0;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.contact .head ul li[data-v-21ba3a83]{margin-left:20px}.contact .head ul li .el-select[data-v-21ba3a83]{width:100%}.contact .head ul li .el-date-editor[data-v-21ba3a83]{width:100%}\n", ""]);

// exports
